import React from 'react';
import { StyledTagNewWrapper } from '@src/containers/Layout/SidebarNew/DesktopSidebar/index.style';
import Typography from '@src/new-components/Typography';
import { useTranslation } from 'react-i18next';

const NewFeature = () => {
  const { t } = useTranslation();
  return (
    <StyledTagNewWrapper>
      <Typography variant="body-12-medium">{t('new')}</Typography>
    </StyledTagNewWrapper>
  );
};

export default NewFeature;
